import { ReactElement, useMemo } from 'react';
import { isNumber } from 'lodash';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { ReceptionServiceEstimatedDurationValue } from '../../../ReceptionServiceEstimatedDurationField';
import { ReceptionServicePractitionerValue } from '../../receptionServicePractitioner.types';
import { usingDefaultConfigurationVisitor } from '../ReceptionServicePractitionersInteractiveTable.utils';

type ReceptionServiceEstimatedDurationCellProps = InteractiveTableCellProps<ReceptionServiceEstimatedDurationValue> & {
   readonly defaultValue: ReceptionServiceEstimatedDurationValue;
};

export const ReceptionServiceEstimatedDurationCell = (
   props: ReceptionServiceEstimatedDurationCellProps
): ReactElement => {
   const { getCellValue } = useInteractiveTableContext<ReceptionServicePractitionerValue>();
   const usingDefaultConfiguration = getCellValue('usingDefaultConfiguration', props.index);

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return { required: !usingDefaultConfiguration };
   }, [usingDefaultConfiguration]);

   return usingDefaultConfigurationVisitor(usingDefaultConfiguration)({
      withDefaultConfiguration: () => (
         <InteractiveTable.TextViewCell
            name={props.name}
            testId={props.testId}
            defaultValue={props.defaultValue}
            index={props.index}
            validationRules={validationRules}
            renderer={(value) => (isNumber(value) ? `${value} min` : '')}
         />
      ),
      withIndividualConfiguration: () => (
         <InteractiveTable.MinuteInputCell
            disabled={usingDefaultConfiguration}
            name={props.name}
            testId={props.testId}
            defaultValue={props.defaultValue}
            index={props.index}
            validationRules={validationRules}
         />
      ),
   });
};
